<template>
  <PlayerLayout>
    <div class="d-flex flex-column flex-md-row mx-12 my-6" slot="main">
      <v-sheet v-if="idea" class="d-flex flex-column flex-1" color="grey-lighten-4" rounded>
        <div class="d-flex flex-column">
          <div class="cal-sans-regular font-size-26">{{ idea.title || idea.name }}</div>
          <div class="cal-sans-regular font-size-16 my-2">{{ idea.description }}</div>
          
          <v-btn v-if="authUser" @click="riff" color="grey lighten-2" class="black--text elevation-0 mt-2">
            <v-icon left>mdi-guitar-pick-outline</v-icon>
            Riff
          </v-btn>

          <v-btn v-if="authUser && idea.creator && authUser.uid === idea.creator.id" @click="edit" color="grey lighten-2" class="black--text elevation-0 mt-2">
            <v-icon left>mdi-pencil</v-icon>
            Edit Idea
          </v-btn>
        </div>
      </v-sheet>
      <v-sheet v-else-if="loading" class="d-flex flex-column flex-1" color="grey-lighten-4" rounded>
        <v-progress-linear indeterminate></v-progress-linear>
      </v-sheet>
    </div>
  </PlayerLayout>
</template>

<script>
import { getDoc, doc } from 'firebase/firestore';
import { db } from '@/firebase/init';
import PlayerLayout from '@/layouts/Player.vue';

export default {
  name: 'IdeaPlayer',
  components: {
    PlayerLayout,
  },
  data() {
    return {
      idea_id: null,
      loading: false,
      idea: null,
    };
  },
  methods: {
    loadIdea() {
      this.loading = true;
      this.idea_id = this.$route.params.id;
      if (this.idea_id) {
        const ideaRef = doc(db, 'ideas', this.idea_id);
        getDoc(ideaRef)
          .then((doc) => {
            if (doc.exists()) {
              let ideaData = doc.data();
              ideaData.id = doc.id;
              this.idea = ideaData;
            } else {
              console.error('No such document!');
              this.idea = null;
            }
            this.loading = false;
          })
          .catch((error) => {
            console.error('Error getting document:', error);
            this.loading = false;
            this.idea = null;
          });
      } else {
        this.loading = false;
      }
    },
    async riff() {
      await this.$creator.riff('idea', this.idea.id, this.profile);
    },
    edit() {
      this.$creator.edit('idea', this.idea.id);
    }
  },
  created() {
    this.loadIdea();
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler(newId, oldId) {
        if (newId !== oldId) {
          this.loadIdea();
        }
      },
    },
  },
};
</script>
